import { useMusic } from "@/context/music";

export default function ArtistProfileMusicSetupTab({ tracks, artistPageUrl }) {
  const { playTrack, activeTrack, isPlaying } = useMusic();

  const formatDuration = (durationSec) => {
    const minutes = Math.floor(durationSec / 60);
    const seconds = Math.floor(durationSec % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const PlayIcon = (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <path
          d="M13.2342 23.0449C19.3403 23.0449 24.2903 18.355 24.2903 12.5698C24.2903 6.78458 19.3403 2.09473 13.2342 2.09473C7.12817 2.09473 2.17822 6.78458 2.17822 12.5698C2.17822 18.355 7.12817 23.0449 13.2342 23.0449Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.66309 12.8115V11.0621C9.66309 8.88331 11.2883 7.99293 13.2784 9.08233L14.8815 9.96224L16.4846 10.8421C18.4747 11.9316 18.4747 13.7123 16.4846 14.8017L14.8815 15.6816L13.2784 16.5615C11.2883 17.6509 9.66309 16.7606 9.66309 14.5818V12.8115Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
  const PauseIcon = (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0298 16.8752V5.0252C10.0298 3.9002 9.493 3.4502 8.13684 3.4502H4.71818C3.36201 3.4502 2.8252 3.9002 2.8252 5.0252V16.8752C2.8252 18.0002 3.36201 18.4502 4.71818 18.4502H8.13684C9.493 18.4502 10.0298 18.0002 10.0298 16.8752Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7774 16.8752V5.0252C19.7774 3.9002 19.2406 3.4502 17.8844 3.4502H14.4657C13.119 3.4502 12.5728 3.9002 12.5728 5.0252V16.8752C12.5728 18.0002 13.1096 18.4502 14.4657 18.4502H17.8844C19.2406 18.4502 19.7774 18.0002 19.7774 16.8752Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (!tracks || tracks.length === 0) {
    return (
      <div className="pt-6 lg:pl-[100px] pb-6 flex flex-col items-center justify-center min-h-[200px]">
        <div className="text-white font-urbanist text-2xl font-bold mb-2">
          No Music Added
        </div>
        <div className="text-[#979797] font-urbanist text-base">
          This artist hasn&#39;t added music
        </div>
      </div>
    );
  }

  return (
    <div className="pt-6 lg:pl-[100px] pb-6">
      <div className=" hidden md:block ">
        {tracks.map((track, idx) => (
          <div key={track.id}>
            <div
              className="grid grid-cols-4 items-center w-full gap-1 lg:gap-4 px-4 py-4 cursor-pointer relative lg:pt-[50px] lg:pb-6 lg:grid-cols-4 lg:px-0 lg:py-0"
              onClick={() => playTrack({ ...track, artistPageUrl })}
            >
              <div className="flex items-start gap-4 col-span-3 md:col-span-2 lg:gap-[41px] lg:ml-6">
                <img
                  src={track.image_url}
                  alt={track.name}
                  className="w-[80px] h-[80px] rounded-lg object-cover lg:w-[80px] lg:h-[80px]"
                />
                <div className="flex flex-col">
                  <div className="text-white font-urbanist font-semibold text-[16px] leading-[20px] truncate text-wrap lg:text-[20px] lg:leading-[24px] mb-1">
                    {track.name}
                  </div>
                  <div className="text-[#979797] text-wrap truncate font-urbanist font-medium text-[14px] leading-[18px] lg:text-[16px]">
                    {track.artists_name}
                  </div>
                </div>
              </div>

              <div className="text-white text-sm hidden md:block font-medium text-center lg:font-urbanist lg:text-[18px] lg:leading-[8px]">
                {formatDuration(track.duration_ms / 1000)}
              </div>

              <div className="flex items-center justify-end min-w-[40px] lg:min-w-[120px] lg:ml-6">
                <span>
                  {activeTrack?.id === track.id && isPlaying ? PauseIcon : PlayIcon}
                </span>
              </div>
            </div>

            {tracks.length > 1 && (
              <div className="border-b border-[#424242] opacity-60 w-full lg:border-[0.4px]" />
            )}
          </div>
        ))}
      </div>

      <div className="md:hidden flex flex-col gap-4">
        {tracks.map((track, idx) => (
          <div key={track.id} className=" bg-[#29292c] rounded-2xl ">
            <div
              className="flex justify-between p-3 pr-2.5 "
              onClick={() => playTrack({ ...track, artistPageUrl })}
            >
              <div className="flex items-start gap-4 col-span-3 md:col-span-2 lg:gap-[41px] lg:ml-6">
                <img
                  src={track.image_url}
                  alt={track.name}
                  className="w-[80px] h-[80px] rounded-lg object-cover lg:w-[80px] lg:h-[88.57px]"
                />
                <div className="flex flex-col">
                  <div className="text-white font-urbanist font-semibold text-[14px] leading-[18px] truncate text-wrap lg:text-[22px] lg:leading-[26px] mb-1">
                    {track.name}
                  </div>
                  <div className="text-[#979797] text-wrap truncate font-urbanist font-medium text-[12px] leading-[16px] lg:text-[18px]">
                    {track.artists_name}
                  </div>
                </div>
              </div>

              <div className="text-white text-sm hidden md:block font-medium text-center lg:font-urbanist lg:text-[18px] lg:leading-[8px]">
                {formatDuration(track.duration_ms / 1000)}
              </div>

              <div className="flex items-center justify-end min-w-[40px] lg:min-w-[120px] lg:ml-6">
                <span>
                  {activeTrack?.id === track.id && isPlaying ? PauseIcon : PlayIcon}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}